import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from "react-redux"
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import RightbarDI from 'pages/main/documentsIn/Rightbar'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'

import { httpOk, GET, FILE_D } from 'helpers/api'
import { formatMoney, returnSign, findKeyFromArrayByValue, formatDate } from 'helpers/helpers'
import { businessToday, businessMonthStart } from 'helpers/businessDay'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const groupBy = [
		{ 'id': 'wms', 'name': t('wms') },
		{ 'id': 'category', 'name': t('category') },
		{ 'id': 'product', 'name': t('product') },
		{ 'id': 'supplier', 'name': t('supplier') },
	]

	const statuses = [
		{ 'id': 1, 'name': t('success') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const [data, setData] = useState([])
	const [products, setProducts] = useState([])
	const [wms, setWms] = useState([])
	const [poses, setPoses] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [categories, setCategories] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showRightBar, setShowRightBar] = useState({
		'document_in': false,
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		'start_date': businessToday(),
		'end_date': businessToday(),
		pos_id: reduxAccount.pos_id,
		wms_id: null,
		status: 1,
		supplier_id: null,
		category_id: null,
		product_id: null,
		group_by: null,
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/report-incomes',
		response: null
	})

	function buildFilterParams(filterDataCopy = {}, options = {}) {
		const { includePage = true } = options
		var urlParams = ""

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.wms_id)
			urlParams += returnSign(urlParams) + 'wms_id=' + filterDataCopy.wms_id
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.supplier_id)
			urlParams += returnSign(urlParams) + 'supplier_id=' + filterDataCopy.supplier_id
		if (filterDataCopy.category_id)
			urlParams += returnSign(urlParams) + 'category_id=' + filterDataCopy.category_id
		if (filterDataCopy.product_id)
			urlParams += returnSign(urlParams) + 'product_id=' + filterDataCopy.product_id
		if (filterDataCopy.group_by)
			urlParams += returnSign(urlParams) + 'group_by=' + filterDataCopy.group_by
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (includePage && filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		return urlParams
	}

	async function searchWithFilter(passedData = {}) {
		var filterUrl = "/report-incomes"
		const filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		checkFilter(filterDataCopy)

		const urlParams = buildFilterParams(filterDataCopy, { includePage: true })

		if (`/report-incomes${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setFilterData(filterDataCopy)
		setDropdownIsOpen(false)
	}

	async function downloadExcelFile() {
		let urlParams = buildFilterParams({ ...filterData }, { includePage: false })
		urlParams += returnSign(urlParams) + 'excel=true'
		const response = await FILE_D('/report-incomes' + urlParams)
		if (httpOk(response)) {
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileUrl = URL.createObjectURL(file)
			const link = document.createElement('a')
			link.href = fileUrl
			link.setAttribute('download', `${t('good_reception')}.xlsx`)
			document.body.appendChild(link)
			link.click()
			URL.revokeObjectURL(fileUrl)
		}
	}

	async function toggleRightbarDI(boolean = false, item) {
		if (boolean && !item.document_in_id) return
		if (boolean) {
			const response = await GET(`/documents-in/${item.document_in_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar({ ...showRightBar, 'document_in': true })
			}
		} else {
			setSelectedItem({})
			setShowRightBar({ ...showRightBar, 'document_in': false })
		}
	}

	function resetFilter() {
		const next = {
			start_date: businessMonthStart(),
			end_date: businessToday(),
			pos_id: reduxAccount.pos_id,
			wms_id: null,
			status: 1,
			supplier_id: null,
			category_id: null,
			product_id: null,
			group_by: null,
			search: '',
			page: null,
		}
		setFilterData(next)
		setFilterDataExist(false)
		getWms(next.pos_id)
		searchWithFilter({ filterData: next })
	}

	function checkFilter(currentFilterData = filterData) {
		if (
			currentFilterData.pos_id === null &&
			currentFilterData.wms_id === null &&
			currentFilterData.supplier_id === null &&
			currentFilterData.category_id === null &&
			currentFilterData.product_id === null &&
			!currentFilterData.group_by &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page) {
		const nextFilterData = { ...filterData, 'page': page }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getSuppliers() {
		const response = await GET('/helper/suppliers')
		if (httpOk(response)) setSuppliers(response.data)
	}

	async function getCategories() {
		const response = await GET('/helper/categories')
		if (httpOk(response)) setCategories(response.data)
	}

	async function getWms(pos_id = null) {
		var filterPosId = pos_id ?? filterData.pos_id
		const response = await GET(`/helper/wms?pos_id=${filterPosId}`)
		if (httpOk(response)) setWms(response.data)
	}

	async function getProducts() {
		const response = await GET(`/helper/elements`)
		if (httpOk(response)) setProducts(response.data)
	}

	useEffect(() => {
		getPoses()
		getWms()
		getSuppliers()
		getCategories()
		getProducts()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">
					{t('good_reception')} [{pagination?.response?.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}
									onSearchChange={(search) => {
										const nextFilterData = { ...filterData, search, page: null }
										setFilterData(nextFilterData)
										searchWithFilter({ filterData: nextFilterData })
									}}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => {
														setFilterData({ ...filterData, 'pos_id': option.id })
														getWms(option.id)
													}}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('wms')}</label>
												<Select
													isClearable
													options={wms}
													value={wms.find(option => option.id === filterData.wms_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'wms_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('supplier')}</label>
												<Select
													isClearable
													options={suppliers}
													value={suppliers.find(option => option.id === filterData.supplier_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'supplier_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('category')}</label>
												<Select
													isClearable
													options={categories}
													value={categories.find(option => option.id === filterData.category_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'category_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('products')}</label>
												<Select
													isClearable
													options={products}
													value={products.find(option => option.id === filterData.product_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'product_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('group')}</label>
												<Select
													isClearable
													options={groupBy}
													value={groupBy.find(option => option.id === filterData.group_by) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'group_by': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => setFilterData({ ...filterData, ...period })}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="d-flex justify-content-end gap-2">
											<button className="btn btn-secondary"
												onClick={() => setDropdownIsOpen(false)}>
												{t('cancel')}
											</button>
											<button className="btn btn-primary"
												onClick={() => searchWithFilter({ filterData: { ...filterData, page: null } })}>
												{t('apply')}
											</button>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide-2"
									onClick={() => downloadExcelFile()}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
						<div className="vertical-center">
							<h4><b>{t('amount')}</b>: {formatMoney(data.total_amount)}</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.wms_id &&
									<span className="me-2">
										<b>{t('wms')}: </b>
										{findKeyFromArrayByValue(wms, 'id', filterData.wms_id, 'name')}
									</span>
								}
								{filterData.supplier_id &&
									<span className="me-2">
										<b>{t('supplier')}: </b>
										{findKeyFromArrayByValue(suppliers, 'id', filterData.supplier_id, 'name')}
									</span>
								}
								{filterData.category_id &&
									<span className="me-2">
										<b>{t('category')}: </b>
										{findKeyFromArrayByValue(categories, 'id', filterData.category_id, 'name')}
									</span>
								}
								{filterData.group_by &&
									<span className="me-2">
										<b>{t('group')}: </b>
										{findKeyFromArrayByValue(groupBy, 'id', filterData.group_by, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }}>{t('category')}</th>
									<th style={{ 'width': '15%' }}>{t('wms')}</th>
									<th style={{ 'width': '10%' }}>{t('supplier')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="text-start">{t('unit')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}
										className={item.document_in_id ? 'cursor' : ''}
										onClick={() => toggleRightbarDI(true, item)}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis" title={item.product_name}>{item.product_name}</td>
										<td className="td-ellipsis" title={item.category_name}>{item.category_name}</td>
										<td className="td-ellipsis" title={item.wms_name}>{item.wms_name}</td>
										<td className="td-ellipsis" title={item.supplier_name}>{item.supplier_name}</td>
										<td className="text-end text-nowrap">{formatMoney(item.quantity, 2)}</td>
										<td className="text-start">{item.unit_name}</td>
										<td className="text-end text-nowrap">{formatMoney(item.price)}</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_price)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.total_quantity)}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.total_amount)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{showRightBar.document_in &&
				<RightbarDI
					showRightBar={showRightBar.document_in}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</RightbarDI>
			}
		</>
	)
}

export default Index